import { ScrollHideForm } from "./scroll-hide-form";
import { bindScrollHide } from "./scroll-hide-listener";

export function setupScrollHide(): void {
    const form = new ScrollHideForm();
    const navbar = form.getNavbar();
    const footer = form.getFooter();

    if (!navbar && !footer) return;

    if (footer) {
        document.documentElement.style.setProperty("--footer-height", `${footer.offsetHeight}px`);
    }

    bindScrollHide(navbar, footer);
}
